var _excluded = ["title", "subtitle", "description", "currency", "suffix", "price", "period", "children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import { string, node } from 'prop-types';
import theme from '../../../Theme/helpers/themeReader';
import Text from '../../../Text';
import Content from '../Card/Content';
import Subtitle from './Subtitle';
import Divider from '../../../Divider';
var Wrapper = styled(Content)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"])));
var Title = styled(Text.Medium)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  var _theme = theme(props),
      _theme$components = _theme.components,
      card = _theme$components.card,
      cardweb = _theme$components.cardweb;

  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      margin-bottom: ", "px;\n      line-height: ", "px;\n    "])), card.plan.title.color, cardweb.plan.title.margin.bottom, cardweb.plan.title.lineHeight);
});
var Description = styled(Text.Small)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  height: 40px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  color: ", ";\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-overflow: -o-ellipsis-lastline;\n"])), theme.components.card.plan.description.color);
var Price = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  ", "\n"])), function (props) {
  var _theme2 = theme(props),
      cardweb = _theme2.components.cardweb;

  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      margin-bottom: ", "px;\n    "])), cardweb.plan.price.margin.bottom);
});
var EnhancePrice = styled(Text.Medium)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  align-self: center;\n"])));

var PlanCardContent = function PlanCardContent(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description,
      currency = _ref.currency,
      suffix = _ref.suffix,
      price = _ref.price,
      period = _ref.period,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Wrapper, rest, subtitle && /*#__PURE__*/React.createElement(Subtitle, null, subtitle), title && /*#__PURE__*/React.createElement(Title, null, title), description && /*#__PURE__*/React.createElement(Description, null, description), /*#__PURE__*/React.createElement(Price, null, currency && /*#__PURE__*/React.createElement(Text.H4, {
    as: "sup"
  }, currency), price && /*#__PURE__*/React.createElement(Text.H4, {
    as: "strong"
  }, price), suffix && /*#__PURE__*/React.createElement(Text.H4, {
    as: "sup"
  }, suffix), period && /*#__PURE__*/React.createElement(EnhancePrice, {
    as: "sub"
  }, period)), /*#__PURE__*/React.createElement(Divider, null), children);
};

PlanCardContent.propTypes = {
  /** plan name */
  title: string.isRequired,

  /** currency of the current country */
  currency: string,

  /** suffix currency of the current country */
  suffix: string,
  price: string.isRequired,

  /** period that this price will be charged  */
  period: string.isRequired,
  description: string,
  subtitle: string,
  children: node
};
PlanCardContent.defaultProps = {
  children: null,
  description: null,
  subtitle: null,
  currency: null,
  suffix: null
};
PlanCardContent.displayName = 'PlanCard.Content';
export default PlanCardContent;